var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpensePack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: 2,
  stroke: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.75 5.25c0-.828.672-1.5 1.5-1.5h3c.828 0 1.5.672 1.5 1.5v3c0 .828-.672 1.5-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13.75 5.25c0-.828.672-1.5 1.5-1.5h3c.828 0 1.5.672 1.5 1.5v3c0 .828-.672 1.5-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.75 15.25c0-.828.672-1.5 1.5-1.5h3c.828 0 1.5.672 1.5 1.5v3c0 .828-.672 1.5-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13.75 15.25c0-.828.672-1.5 1.5-1.5h3c.828 0 1.5.672 1.5 1.5v3c0 .828-.672 1.5-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3Z"
})));
export default SvgExpensePack;